import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, QrCode, Megaphone, TrendingUp, Activity } from 'lucide-react';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/stats/overview')
      .then(res => setStats(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ display:'flex', justifyContent:'center', padding:80 }}><div className="spinner" style={{ width:36, height:36, borderColor:'rgba(107,33,168,0.3)', borderTopColor:'var(--purple-800)' }} /></div>;

  const cards = [
    { label: 'Total Doctors', value: stats?.totalDoctors || 0, icon: Users, color: '#6B21A8' },
    { label: 'Total Scans', value: stats?.totalScans || 0, icon: QrCode, color: '#0891B2' },
    { label: 'Campaigns', value: stats?.totalCampaigns || 0, icon: Megaphone, color: '#059669' },
    { label: "Today's Scans", value: stats?.todayScans || 0, icon: TrendingUp, color: '#D97706' },
  ];

  const maxScans = Math.max(...(stats?.last7?.map(d => d.scans) || [1]), 1);

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Dashboard</h1>
          <p>Welcome back · Here's what's happening today</p>
        </div>
      </div>

      <div className="grid-4" style={{ marginBottom: 28 }}>
        {cards.map(({ label, value, icon: Icon, color }) => (
          <div className="stat-card" key={label} style={{ borderTop: `3px solid ${color}` }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
              <div>
                <div className="stat-label">{label}</div>
                <div className="stat-number" style={{ color }}>{value}</div>
              </div>
              <div style={{ width:42, height:42, background:`${color}15`, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <Icon size={20} color={color} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:24 }}>
          <Activity size={18} color="var(--purple-800)" />
          <h3 style={{ fontSize:'1rem' }}>Scan Activity — Last 7 Days</h3>
        </div>
        <div style={{ display:'flex', alignItems:'flex-end', gap:12, height:160 }}>
          {stats?.last7?.map((day, i) => (
            <div key={i} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:6 }}>
              <div style={{ fontSize:'0.7rem', color:'var(--gray-400)', fontWeight:600 }}>{day.scans}</div>
              <div style={{
                width:'100%', borderRadius:6,
                background: `linear-gradient(180deg, var(--purple-600), var(--purple-800))`,
                height: `${Math.max((day.scans / maxScans) * 120, 6)}px`,
                transition: 'height 0.5s ease',
                opacity: day.scans === 0 ? 0.2 : 1
              }} />
              <div style={{ fontSize:'0.7rem', color:'var(--gray-400)' }}>{day.date}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
